import useFetch from '@/composables/useFetch';
import { PaginationResponse } from '@/model/api';
import { Doujin, DoujinDetail, DoujinOption, DoujinPaginationRequest } from '@/model/doujin';
import { HttpStatusCode } from 'axios';

export async function getDoujinsPagination(filter: DoujinPaginationRequest) {
	const res = await useFetch<PaginationResponse<Doujin>>({
		method: 'GET',
		url: '/doujin',
		params: filter,
		signalUUID: `GET_DOUJIN_PAGINATION`
	});
	return res.data;
}

export async function getImage(url: string) {
	const res = await useFetch<Blob>({
		method: 'POST',
		url: '/doujin/image',
		data: { url },
		responseType: 'blob'
	});
	if (res.status === HttpStatusCode.Ok && res.headers && res.headers['content-type']) {
		return { data: res.data, mimeType: res.headers['content-type'].toString() };
	}
	throw Error(res.status?.toString() || 'Something went wrong!');
}

export async function scrapingViaAPI(url: string) {
	const res = await useFetch<DoujinDetail>({
		method: 'POST',
		url: '/doujin/scraping',
		data: { url }
	});
	return res.data;
}

export async function getDoujinOption() {
	const res = await useFetch<DoujinOption>({
		method: 'GET',
		url: `/doujin/option`
	});
	return res.data;
}

export async function getDoujin(doujinUUID: string) {
	return await useFetch<Doujin>({
		method: 'GET',
		url: `/doujin/${doujinUUID}`
	});
}

export async function createDoujin(doujin: DoujinDetail) {
	return await useFetch({
		method: 'POST',
		url: '/doujin',
		data: doujin,
		timeout: 1000 * 60 * 30 // 30 minutes
	});
}

export async function deleteDoujin(doujinUUID: string) {
	return await useFetch<Doujin>({
		method: 'DELETE',
		url: `/doujin/${doujinUUID}`
	});
}

export async function favoriteDoujin(doujinUUID: string, isFavorite: boolean) {
	return await useFetch({
		method: 'PATCH',
		url: `/doujin/${doujinUUID}/favorite`,
		data: { isFavorite }
	});
}

export async function ratingDoujin(doujinUUID: string, score: number) {
	return await useFetch({
		method: 'PATCH',
		url: `/doujin/${doujinUUID}/rating`,
		data: { score }
	});
}
